import * as React from "react";
import { cn } from "@/lib/utils";

export interface NumPillProps extends React.HTMLAttributes<HTMLSpanElement> {
  inverted?: boolean;
}

export function NumPill({ inverted = false, className, children, ...props }: NumPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center font-mono text-[10.5px] leading-none tabular-nums",
        "h-4 min-w-4 px-1.5 rounded-1",
        inverted ? "bg-white/15 text-white" : "bg-surface-1 text-ink-700 border border-line",
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
